import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Tailwind-aware class joiner used by shadcn components.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
